import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from "element-plus";
import "element-plus/dist/index.css"; // Element Plus 的基础样式
import "element-plus/theme-chalk/dark/css-vars.css"; // 使用暗黑主题（可选）
import * as ElIcons from "@element-plus/icons-vue"; // 引入 Element Plus 图标
import ja from "element-plus/dist/locale/ja.mjs"; // 引入日语语言包
// 引入全局样式
import "@/styles/global.css";

const app = createApp(App);

// 注册 Element Plus 图标组件
for (const [key, component] of Object.entries(ElIcons)) {
  app.component(key, component);
}

// 全局设置 Element Plus 语言为日语
app.use(ElementPlus, { locale: ja });
app.use(router); // 注册路由（如果有）
app.use(ElementPlus); // 注册 Element Plus
app.mount("#app"); // 挂载应用